import React, { Component } from 'react';
import styles from './flexSetImagesGrid.scss';
import classNames from 'classnames';
import TabNavigationHelper from '../../../../Common/tabNavigationHelper';
import { IL10N } from '../../../../Common/l10n-keys';
import IconArrowSmallLeft from '../../../../Assets/svg/icon_arrow_small_left';
import IconArrowSmallRight from '../../../../Assets/svg/icon_arrow_small_right';
import * as helper from '../../../../Common/html-helper'

export default class FlexSetImagesGrid extends Component<FlexSetImagesGridProps,
    { currentPage: number }> {

    private readonly slideShowRef = React.createRef<HTMLDivElement>();
    private readonly slidesRef = React.createRef<HTMLDivElement>();
    private readonly imgDividerRef = React.createRef<HTMLDivElement>();
    private tabNav: TabNavigationHelper;
    private MaxImagesPrePage = 4;
    private totalImageTileCont: number;
    private totalPage: number;
    private freeArticleCount: number;
    constructor(props) {
        super(props);
        this.tabNav = TabNavigationHelper.instance;
        this.totalImageTileCont =
            this.props.gratisImages?.length > 0 ? this.props.images.length + 1 : this.props.images.length;
        this.totalPage = Math.ceil(this.totalImageTileCont / this.MaxImagesPrePage);
        this.freeArticleCount = this.props.gratisImages?.length > 0 ?
            this.props.gratisImages?.reduce((n, image) => n + image.quantity, 0) : 0;
        this.state = {
            currentPage: 1,
        };
    }

    componentDidMount(): void {
        // firs component init, it helps to avoid transition during page load:
        if (this.slideShowRef.current) {
            this.tabNav.setGroupAtt(this.slideShowRef.current);
        }
    }

    private gridStyles(totalCount: number, isFreeItemsGrid: boolean): string {
        const baseStyle = isFreeItemsGrid ? styles.fi_image_grid : styles.image_grid;
        const fullSizeStyle = this.props.isMobile && this.props.setDiscount <= 0 ? styles.full_size : '';
        let addOn = '';
        switch (totalCount) {
            case 1: {
                addOn = styles.single;
                break;
            }
            case 2: {
                addOn = styles.double;
                break;
            }
            case 3: {
                addOn = styles.triple;
                break;
            }
        }
        return [baseStyle, fullSizeStyle, addOn].join(' ');
    }

    private imageStyles(imageIndex: number, isFreeItemsGrid: boolean): string {
        // index start with 1
        const baseClass = isFreeItemsGrid ? styles.fi_image_cell : styles.image_cell;
        const baseStyles = [classNames(baseClass), imageIndex.toString()].join(' ');
        return baseStyles;
    }

    private getImageSrcSet(imgUrl: string): string {
        if (imgUrl) {
            // DPR related subfix
            const subFix = this.props.isMobile ? ' 1200w,' : ' 768w,';

            // up to 768:
            const path_768 = imgUrl.replace('ArticleTileV3', 'TileImage768') + subFix;

            // up to HD:
            const path_hd = imgUrl + ' 1800w'

            return path_768 + ' ' + path_hd;
        }
        return null;
    }

    private getGridStyle(tileCount?: number): React.CSSProperties {
        const totalTileCount = tileCount ? tileCount : this.totalImageTileCont;
        const count = Math.ceil(totalTileCount / 2);
        return { gridTemplateColumns: `repeat(${count}, 50%)` }
    }

    private getVerticalDivider(imageAmount: number): JSX.Element {
        if (this.props.fspImage.fullPath?.length > 0)
            return;

        return imageAmount >= 3 ?
            <div className={classNames(styles.img_divider,
                imageAmount == 3 ? styles.threeTypeDiv : ''
            )} ref={this.imgDividerRef} /> : null;
    }

    private getHorizontalDivider(imageAmount: number): JSX.Element {
        if (this.props.fspImage.fullPath?.length > 0)
            return;

        return imageAmount >= 2 ? <div className={styles.img_h_divider}
            style={{ width: ((this.totalPage + 1) * 100).toString() + '%' }} /> : null;
    }

    private createSlideShow(): JSX.Element {
        let slidShowPage = 1;
        const lastPage = Math.ceil(this.totalImageTileCont / 4);
        let lastPageStyles = ''; // styles for last slide show page last_1, last_2, last_3
        // remaining images in last slide show page
        const remainingImages = this.totalImageTileCont - ((lastPage - 1) * 4);

        return (<>
            <div
                className={this.gridStyles(this.totalImageTileCont, false)}
                data-testid='slides' data-semantic-id='slides'
                ref={this.slidesRef}
            >
                {
                    this.props.fspImage.fullPath?.length > 0 ?
                    <div className={styles.main_fsp_image}>
                        <img src={this.props.fspImage.fullPath}
                            srcSet={this.getImageSrcSet(this.props.fspImage.fullPath)}
                            loading='lazy'
                            decoding={'sync'}
                            alt={this.props.fspImage.imageAlt}
                            data-testid={'slide'} ></img>
                    </div>
                    : 
                    Array.from({ length: this.totalImageTileCont }).map((_, i) => {
                        // creating page number for images:
                        const tmp_i = i + 1;

                        if ((slidShowPage * 4) < tmp_i)
                            slidShowPage++;

                        // create last slide show page styles:
                        if (lastPage === slidShowPage && this.totalImageTileCont > 2) {
                            const lastPageStyleSubfix = remainingImages === 0 ? 1 : remainingImages;
                            lastPageStyles = 'fas_last_' + lastPageStyleSubfix.toString();
                        }

                        if (this.props.gratisImages?.length > 0) {
                            if (this.totalImageTileCont > 3) {
                                if (i == 3) {
                                    return this.freeArticleTile(i, slidShowPage);
                                } else if (i < 3) {
                                    return this.imageTile(this.props.images[i], i, slidShowPage, lastPageStyles);
                                } else {
                                    const tmpIndex = i - 1;
                                    return this.imageTile(this.props.images[tmpIndex], i, slidShowPage, lastPageStyles);
                                }
                            } else {
                                if (i == this.totalImageTileCont - 1) {
                                    return this.freeArticleTile(i);
                                } else {
                                    return this.imageTile(this.props.images[i], i, 1, lastPageStyles);
                                }
                            }
                        } else {
                            return this.imageTile(this.props.images[i], i, slidShowPage, lastPageStyles);
                        }
                    })
                }
                {
                    this.getVerticalDivider(this.totalImageTileCont)
                }
                {
                    this.getHorizontalDivider(this.totalImageTileCont)
                }
            </div>

        </>);
    }

    private imageTile(img: IFlexSetImageFileData, imageIndex: number,
        slidShowPage = 1, lastPageStyles): JSX.Element {
        if (img) {
            const tmpIndex = imageIndex + 1;
            return (
                <div className={classNames(this.imageStyles(tmpIndex, false),
                    'sp_' + slidShowPage.toString(),
                    slidShowPage === 1 ? styles.active_img : styles.hidden_img,
                    lastPageStyles)}
                    key={tmpIndex}>
                    {img.quantity && img.quantity > 1 &&
                        <div className={styles.quantity}>{img.quantity.toString() + 'x'}</div>}
                    < img src={img.fullPath}
                        srcSet={this.getImageSrcSet(img.fullPath)}
                        loading='lazy'
                        key={tmpIndex}
                        decoding={'sync'}
                        data-index={tmpIndex}
                        alt={img.imageAlt}
                        data-testid={'slide'} >
                    </img>
                </div>
            );
        }
    }

    private freeArticleTile(index: number, slidShowPage = 1): JSX.Element {
        const tmpIndex = index + 1;
        const displayMore = this.props.gratisImages?.length > 4;
        const displayGratisImages = displayMore ?
            this.props.gratisImages.slice(0, 3) : this.props.gratisImages;
        if (this.props.gratisImages?.length > 0) {
            return (
                <div className={classNames(this.imageStyles(tmpIndex, false),
                    styles.free_article_grid,
                    'sp_' + slidShowPage.toString(),
                    slidShowPage === 1 ? styles.active_img : styles.hidden_img)}
                    key={tmpIndex}>
                    <div className={classNames(styles.free_article_label)}>
                        <span className={styles.free_article_label_count}>{this.freeArticleCount}</span>
                        <span className={styles.free_article_label_text}>{this.props.l10n.flexibleSetFreeArticle}</span>
                    </div>
                    <div className={classNames(this.gridStyles(this.props.gratisImages?.length, true))}>
                        {
                            displayGratisImages.map((img, imageIndex) => {
                                const innerTmpIndex = imageIndex + 1;
                                return (
                                    <div className={classNames(this.imageStyles(innerTmpIndex, true), 'fas-free')}
                                        key={innerTmpIndex}>
                                        <img src={img.fullPath}
                                            srcSet={this.getImageSrcSet(img.fullPath)}
                                            loading='lazy'
                                            key={tmpIndex}
                                            decoding={'sync'}
                                            data-index={innerTmpIndex}
                                            alt={img.imageAlt}
                                            data-testid={'slide'} >
                                        </img>
                                    </div>);
                            })
                        }
                        {
                            displayMore &&
                            <div className={classNames(this.imageStyles(4, true), styles.more_image_placeholder)}>
                                <div className={styles.more_image_label}>
                                    <span>{`+${this.props.gratisImages?.length - displayGratisImages.length}`}</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            );
        } else {
            return <></>;
        }
    }

    private createMobileView(): JSX.Element {
        const displayMore = this.props.images.length > 4;
        const displayImages = displayMore ? this.props.images.slice(0, 4) : this.props.images;
        const singleImgHasFreeItems = this.props.images.length === 1 && 
            this.props.gratisImages != null && this.props.gratisImages.length > 0;

        return (<>
            {
                this.props.fspImage.fullPath?.length > 0 ?
                    <div className={classNames(styles.main_fsp_image, {
                        [styles.hidden]: this.props.on_hover
                    })}>
                        <img src={this.props.fspImage.fullPath}
                            srcSet={this.getImageSrcSet(this.props.fspImage.fullPath)}
                            loading='lazy'
                            decoding={'sync'}
                            alt={this.props.fspImage.imageAlt}
                            data-testid={'slide'} ></img>
                    </div> :
                    <div
                        className={classNames(this.gridStyles(displayImages.length, false),
                        {[styles.single_img_has_free_items]: singleImgHasFreeItems})}
                        data-testid='slides' data-semantic-id='slides'
                        ref={this.slidesRef}
                        style={this.getGridStyle(displayImages.length)}
                    >
                        {displayImages.map((img, imageIndex) => {
                            const tmpIndex = imageIndex + 1;
                            return (
                                <div className={classNames(this.imageStyles(tmpIndex, false))} key={tmpIndex}>
                                    <img src={img.fullPath}
                                        srcSet={this.getImageSrcSet(img.fullPath)}
                                        loading='lazy'
                                        key={tmpIndex}
                                        decoding={'sync'}
                                        data-index={tmpIndex}
                                        alt={img.imageAlt}
                                        data-testid={'slide'} >
                                    </img>
                                </div>
                            );
                        })}
                        {
                            this.getVerticalDivider(displayImages.length)
                        }
                        {
                            this.getHorizontalDivider(displayImages.length)
                        }
                    </div>
            }
        </>
        );
    }

    private swipeWithIndexDifference(index: number, event: React.MouseEvent | React.TouchEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (this.slidesRef.current) {
            const previousPage = this.state.currentPage;
            const newPage = previousPage + index;

            // hide previous slide images:
            this.slidesRef.current.querySelectorAll('.sp_' + previousPage.toString())
                .forEach(el => {
                    el.classList.add(styles.hidden_img);
                    el.classList.remove(styles.active_img);
                });

            // display new slide images
            this.slidesRef.current.querySelectorAll('.sp_' + newPage.toString())
                .forEach(el => {
                    el.classList.add(styles.active_img);
                    el.classList.remove(styles.hidden_img);
                });
        }

        this.setState({ currentPage: this.state.currentPage + index });
    }

    private renderPager() {
        // early exit:
        if (this.props.fspImage.fullPath?.length > 0)
            return;

        return (
            this.totalPage > 1 &&
            <div className={classNames(styles.flex_sets_footer_container)}>
                <div className={classNames(styles.swiper, {
                    [styles.swiper_inactive]: this.state.currentPage == 1
                }, styles.swipe_left)}
                    onClick={(event) => this.swipeWithIndexDifference(-1, event)} data-testid='swipe_left_click'
                    data-semantic-id='swipe_left_click'
                    onTouchEnd={(event) => this.swipeWithIndexDifference(-1, event)}>
                    <IconArrowSmallLeft />
                </div>
                <div className={classNames(styles.page_label)}>
                    <span>{`${this.state.currentPage}/${this.totalPage}`}</span>
                </div>
                <div className={classNames(styles.swiper, {
                    [styles.swiper_inactive]: this.state.currentPage == this.totalPage
                }, styles.swipe_right)}
                    onClick={(event) => this.swipeWithIndexDifference(1, event)} data-testid='swipe_right_click'
                    data-semantic-id='swipe_right_click'
                    onTouchEnd={(event) => this.swipeWithIndexDifference(1, event)}>
                    <IconArrowSmallRight />
                </div>
            </div>
        );
    }

    private renderMobileBottom() {
        // early exit, strange but this case exists:
        if (this.props.setDiscount <= 0)
            return;

        // eye catcher or free article view
        if ((this.props.gratisImages == null || this.props.gratisImages.length <= 0)
            && this.props.setDiscount)
            return <div className={classNames(styles.flex_sets_footer_container)}>
                {this.setPriceLabel()}
            </div>
        else if (!this.props.fspImage.fullPath || this.props.fspImage.fullPath.length <= 0) {
            const displaySecond = this.props.gratisImages?.length >= 2;
            const gratis = this.props.gratisImages;
            return (
                <div className={classNames(styles.flex_sets_footer_container)}>
                    <div className={classNames(styles.flex_sets_mobile_gratis)}>
                        <div className={classNames(styles.flex_sets_mobile_gratis_label)}>
                            <span className={classNames(styles.flex_sets_mobile_gratis_count)}>
                                {this.freeArticleCount}
                            </span>
                            <span className={styles.label_uppercase}>{this.props.l10n.flexibleSetFreeArticle}</span>
                        </div>
                        <div className={classNames(styles.flex_sets_mobile_gratis_image)}>
                            < img src={gratis[0].fullPath}
                                srcSet={this.getImageSrcSet(gratis[0].fullPath)}
                                loading='lazy'
                                key={0}
                                decoding={'sync'}
                                data-index={0}
                                alt={gratis[0].imageAlt}
                                data-testid={'slide'} >
                            </img>
                        </div>
                        {
                            displaySecond &&
                            <div className={classNames(styles.flex_sets_mobile_gratis_image)}>
                                < img src={gratis[1].fullPath}
                                    srcSet={this.getImageSrcSet(gratis[1].fullPath)}
                                    loading='lazy'
                                    key={1}
                                    decoding={'sync'}
                                    data-index={1}
                                    alt={gratis[1].imageAlt}
                                    data-testid={'slide'} >
                                </img>
                            </div>
                        }
                    </div>
                </div>
            )
        }
    }

    private setPriceLabel() {
        return (
            <div className={classNames(styles.flex_sets_price)}>
                <span className={styles.label_uppercase}>{`${this.props.l10n.setPrice} -${this.props.setDiscount}%`}</span>
            </div>
        );
    }

    public render() {
        return (
            <div ref={this.slideShowRef} className={classNames(styles.flex_sets_images_container,
                (!this.props.fspImage.fullPath || this.props.fspImage.fullPath.length <= 0) 
                    && this.totalPage > 1 ? styles.has_pager : ''
            )}>
                <div className={classNames(styles.flex_sets_header_label)}>
                    <span className={styles.total_article_count}>{this.props.totalArticleCount}</span>
                    <span>{' ' + helper.decodeHTML(this.props.l10n.articleInSet)}</span>
                </div>

                {this.props.isMobile ? this.createMobileView() : this.createSlideShow()}
                {
                    !this.props.isMobile && this.props.setDiscount > 0 && this.setPriceLabel()
                }
                {this.props.isMobile ? this.renderMobileBottom() : this.renderPager()}
            </div>
        );
    }
}

export interface FlexSetImagesGridProps {
    on_hover: boolean,
    detailsPageLink: string,
    isMobile: boolean,
    preventDefaultEvents,
    categoryName: string,
    totalArticleCount: number,
    images: IFlexSetImageFileData[],
    gratisImages?: IFlexSetImageFileData[],
    fspImage?: IFlexSetImageFileData,
    setDiscount?: number,
    l10n: IL10N,
}

export interface IFlexSetImageFileData {
    fullPath: string;
    imageAlt: string;
    quantity: number,
}

